export const Svg_124 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={70}
    height={70}
    fill="none"
  >
    <path
      fill="url(#a)"
      d="M17.5 61.25v-2.916l4.375-2.917c-2.869 0-5.287-.984-7.256-2.953-1.968-1.969-2.953-4.387-2.953-7.255V17.5c0-4.034 1.872-6.987 5.615-8.859C21.024 6.769 26.93 5.834 35 5.834c8.36 0 14.34.9 17.937 2.698 3.597 1.798 5.396 4.788 5.396 8.968V45.21c0 2.868-.984 5.286-2.953 7.255-1.969 1.969-4.387 2.953-7.255 2.953l4.375 2.917v2.916h-35ZM16.04 30.26h37.917V18.96H16.04V30.26Zm32.084 4.376H16.04h37.917-5.833ZM35.004 47.032c1.115 0 2.062-.39 2.84-1.171.777-.781 1.166-1.729 1.166-2.844 0-1.115-.39-2.062-1.171-2.84-.78-.777-1.728-1.166-2.844-1.166-1.115 0-2.061.39-2.84 1.17-.777.781-1.166 1.73-1.166 2.845 0 1.115.39 2.061 1.171 2.839.78.778 1.729 1.167 2.844 1.167Zm-13.13 4.375h26.25c1.653 0 3.039-.608 4.157-1.823 1.118-1.216 1.677-2.674 1.677-4.375V34.636H16.04v10.573c0 1.701.56 3.16 1.677 4.375 1.118 1.215 2.504 1.823 4.157 1.823ZM35 10.209c-5.834 0-10.039.377-12.615 1.13-2.576.753-4.424 1.835-5.542 3.245h36.532c-.875-1.313-2.735-2.37-5.578-3.172-2.844-.802-7.11-1.203-12.797-1.203Zm0 4.375h18.375-36.532H35Z"
    />
    <defs>
      <linearGradient
        id="a"
        x1={22.458}
        x2={50.535}
        y1={14.146}
        y2={52.411}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
    </defs>
  </svg>
)